"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreChartProps = void 0;
var tslib_1 = require("tslib");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
/**
 * Specifies props that are on bucket chart props but not on core chart props - these must not be passed
 * down to core chart.
 */
var NON_CORE_PROPS = ["backend", "workspace"];
exports.getCoreChartProps = function (chart) {
    return function (props) {
        var propsToUse = chart.propTransformation ? chart.propTransformation(props) : props;
        if (chart.onBeforePropsConversion) {
            chart.onBeforePropsConversion(propsToUse);
        }
        var buckets = chart.bucketsFactory(propsToUse);
        var execution = chart.executionFactory(propsToUse, buckets);
        var nonBucketProps = omit_1.default(propsToUse, chart.bucketPropsKeys);
        var propOverrides = chart.propOverridesFactory
            ? chart.propOverridesFactory(propsToUse, buckets)
            : {};
        var exportTitle = propsToUse.exportTitle || chart.chartName;
        var coreChartProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, nonBucketProps), propOverrides), { execution: execution,
            exportTitle: exportTitle });
        return omit_1.default(coreChartProps, NON_CORE_PROPS);
    };
};
//# sourceMappingURL=chartDefinition.js.map